 /**
  * 姓名 :D
  * 创建时间:2019-3-8
  * 描述: 动态创建弹出框组件
  * 更新记录: 
  * @param component  创建组件对象
  * @param param 传递参数
  * @param fun  保存完过后回调方法
  */
import { Injectable, Injector, ComponentFactoryResolver, ApplicationRef } from '@angular/core';


/**
 * 动态创建弹出框组件
 */
@Injectable()
export class SwCreateModalComponentService {

  /**
   * @ignore
   */
  constructor(private injector: Injector,
    private applicationRef: ApplicationRef,
    private componentFactoryResolver: ComponentFactoryResolver) { }

  /**
   * 创建弹出框组件服务 
   * @param component  组件的对象
   * @param param  传递的参数
   * @param fun  回调喊出
   */
  createModal(component: any, param?: any, fun?: any) {
    //创建dom节点
    const com = document.createElement(component.name);
    //创建动态组件
    const factory = this.componentFactoryResolver.resolveComponentFactory(component);
    const swPhotoAlbumComponentRef = factory.create(this.injector, [], com);
    this.applicationRef.attachView(swPhotoAlbumComponentRef.hostView);

    //组件的关闭事件
    swPhotoAlbumComponentRef.instance["callback"].subscribe(data => {
      if (data){
        //如果 callback 抛出的是 true
        if(data === true){
          //调用传入的回调函数 fun()
          if (fun){
            fun();
          }
        } else {  
          //data存在但是不为true的时候,说明data为回调函数的参数
          if (fun){
            //调用传入的回调函数 fun(data);
            fun(data);
          }
        }
      }
      //从dom元素中移除该组件
      document.body.removeChild(com);
      this.applicationRef.detachView(swPhotoAlbumComponentRef.hostView);
      //将组件销毁
      swPhotoAlbumComponentRef.destroy()

    });
    //传递参数
    if(param)
        swPhotoAlbumComponentRef.instance["param"] = param;

    document.body.appendChild(com);
  }
}
